import { GiRocket } from "react-icons/gi";
import { BsBox } from "react-icons/bs";
import Skeleton from "react-loading-skeleton";
import { Link, useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";
import {
  limitcharactersInString,
  parseAssetTypeInt,
  parseQntAssetsJSON,
} from "../../../utils";
import React from "react";
import useIcons from "../../../hooks/useIcons";

/**
 * The content inside 'Overview' tab in UserProfile Page.
 * @param {Object} data
 * @returns {JSX.Element}
 */
const UserProfileOverview = ({ data }) => {
  const { getURI } = useIcons();
  const userData = data.userData;
  let assetsData = data.assetsData;
  const userPreferences = userData.preferences;
  let qntAssets = 0;
  if (userPreferences && userPreferences.assets) {
    qntAssets = parseQntAssetsJSON(userPreferences.assets);
  }
  const { push } = useHistory();

  //Randomize assets.
  if (assetsData && qntAssets > 0) {
    assetsData = assetsData.sort(() => Math.random() - 0.5);
  }
  if (!assetsData) {
    return skeletonLoading();
  } else if (assetsData === "noData") {
    return emptyAssets();
  } else if (assetsData === "error") {
    return fatalError();
  }

  return (
    <div className="az-profile-body">
      <div className="mg-b-20">
        <h4>Você segue ({qntAssets}) ativos.</h4>
        <p>Confira alguns ativos da sua lista.</p>
      </div>

      <div className="row">
        {
          //Render some user assets.
          assetsData.map((item, i) => {
            if (i < 6) {
              return (
                <div className={"col-md-4 col-sm-6 col-xs-6 mg-b-40"} key={i}>
                  <div className="az-profile-work-list">
                    <div
                      className="media cursor-pointer"
                      onClick={() => {
                        push(`/analysis/${item.encoded_id}`);
                      }}
                    >
                      <div className="media-logo">
                        <img
                          style={{ borderRadius: "50%", height: 56, width: 56 }}
                          alt=""
                          src={getURI(item.icon)}
                        />
                      </div>
                      <div className="media-body">
                        <h6>{limitcharactersInString(item.name, 35)}</h6>
                        <span>
                          {parseAssetTypeInt(item.type)}
                          {item.exchange && " - " + item.exchange}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })
        }
      </div>

      {qntAssets > 5 && (
        <div className="row">
          <p className="mx-auto tx-medium">
            Você tem mais ativos em sua lista, veja todos clicando no botão
            abaixo.
          </p>
        </div>
      )}
      <div className="row">
        <Link
          to={"/following-list"}
          className={
            //Correctly align.
            isMobile ? "mx-auto" : qntAssets === 1 ? "mx-4" : "mx-auto"
          }
        >
          <button
            className="btn btn-az-primary"
            style={{
              borderRadius: 15,
            }}
          >
            Gerenciar meus ativos
          </button>
        </Link>
      </div>

      <div className="mg-b-20" />
    </div>
  );
};

export const UserProfileOverviewMemo = React.memo(UserProfileOverview);

const fatalError = () => {
  return (
    <div className="az-profile-body">
      <div className="text-center">
        <span>
          <GiRocket size={48} />
        </span>
        <h4>Houston, temos um problema!</h4>
        <span>
          Infelizmente, alguns dados não aterrissaram da maneira correta.
          <br />
          <span
            onClick={() => {
              return window.location.reload();
            }}
            className="cursor-pointer tx-primary"
          >
            Clique aqui para tentar novamente.
          </span>
        </span>
      </div>
    </div>
  );
};

const emptyAssets = () => {
  return (
    <div className="az-profile-body">
      <div className="text-center">
        <span>
          <BsBox size={48} />
        </span>
        <h4>Lista vazia</h4>
        <span>
          Você ainda não segue nenhum ativo, assim que você começar a seguir,
          você poderá ver eles aqui.
        </span>
      </div>
    </div>
  );
};

const skeletonLoading = () => {
  return (
    <div className="az-profile-body">
      <h4>
        <Skeleton width={200} />
      </h4>

      <div className="row mg-t-20">
        <div className="col-md-4 col-xl-8">
          <div className="az-profile-work-list">
            <div className="media">
              <div className="media-logo">
                <Skeleton width={50} height={50} borderRadius={50} />
              </div>
              <div className="media-body">
                <h6>
                  <Skeleton width={140} />
                </h6>
                <Skeleton width={100} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mg-b-20" />
    </div>
  );
};
